import { render, staticRenderFns } from "./LeftNavUpperV2.vue?vue&type=template&id=0f3445ee&scoped=true"
import script from "./LeftNavUpperV2.vue?vue&type=script&lang=js"
export * from "./LeftNavUpperV2.vue?vue&type=script&lang=js"
import style0 from "./LeftNavUpperV2.vue?vue&type=style&index=0&id=0f3445ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3445ee",
  null
  
)

export default component.exports